import { UserRole } from '@symfa-inc/providence-types';
import { ReportKey } from '@models/interfaces';

const FULL_REPORTS_ROLES = [
  UserRole.Admin,
  UserRole.AdminIT,
  UserRole.ProjectDataSpecialist,
];

export const getRoleReportKeys = (roles: UserRole[] = []): ReportKey[] => {
  if (roles.some(role => FULL_REPORTS_ROLES.includes(role))) {
    return Object.values(ReportKey);
  }

  return roles.includes(UserRole.Permitting)
    ? [ReportKey.PermittingOverview, ReportKey.BPExpiration]
    : [];
};
